export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13663.7d46c9b3.jpg";